import { render, staticRenderFns } from "./ProfileMenuUserMobile.vue?vue&type=template&id=98603854&scoped=true"
import script from "./ProfileMenuUserMobile.vue?vue&type=script&lang=js"
export * from "./ProfileMenuUserMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98603854",
  null
  
)

export default component.exports